<div style="margin-left: 80%; margin-top: 2%;">
  <button class="noPrint" style="margin-top: 2%; margin-left: 2%;" (click)="exportExcel('Contract_InDetails_Report')"
    mat-raised-button color="primary">
    Export
  </button>

      <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%;" mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

  <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
    Close
  </button>
</div>

<!-- Main Container -->
<div class="container" id="print-section1">
  <!-- Indetail Report Section -->
  <ng-container *ngIf="indetail && !datewise && !officerep">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="3">Vivek Saptahik</th>
          <th colspan="5">Issue Seller Repwise Indetail Registration Report</th>
          <th colspan="2">In Detail</th>
          <th colspan="5">Date: {{ today | date: 'dd-MM-yyyy' }}</th>
          <th colspan="3">Page No</th>
        </tr>
        <tr>
          <th colspan="3">Date From: {{ start_date | date: 'dd-MM-yyyy' }}</th>
          <th colspan="2">To: {{ end_date | date: 'dd-MM-yyyy' }}</th>
          <th colspan="3">Issue/Grantha Category: {{ issue_cat }}</th>
          <th colspan="2">Issue Date: {{ issueDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="5">Issue Name: {{ issue_name }}</th>
          <th colspan="3"></th>
        </tr>
        <tr>
          <th>Sr. No</th>
          <th>Booking Date</th>
          <th>Booking No</th>
          <th colspan="2">Issue Seller Name</th>
          <th>Representative Name</th>
          <th>Office Rep. Name</th>
          <th>RO Number / Instruction</th>
          <th>Issue Copies</th>
          <th>Issue Amt</th>
          <th>Net Amt</th>
          <th>GST 5%</th>
          <th>Total Amt</th>
          <th>Received Amt</th>
          <th>Receipt No and Date</th>
          <th>Pending Amt</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of inDetailsRegReport1; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ item.booking_date }}</td>
            <td>{{ item.booking_no }}</td>
            <td colspan="2">{{ item.issue_seller_name }}</td>
            <td>{{ item.rep_name }}</td>
            <td>{{ item.off_rep_name }}</td>
            <td>{{ item.ro_no }}</td>
            <td>{{ item.advtsize }}</td>
            <td class="right">{{ item.issue_seller_amt }}</td>
            <td class="right">{{ item.amount }}</td>
            <td class="right">{{ toInt(item.sgst) + toInt(item.cgst) }}</td>
            <td class="right">{{ item.igst }}</td>
            <td class="right">{{ item.part_pymt_amt }}</td>
            <td>
              {{ item.rep_rcpt_no }}
              <ng-container *ngIf="item.rcpt_date != '0000-00-00'">
                <br />{{ item.rcpt_date | date: 'dd-MM-yyyy' }}
              </ng-container>
            </td>
            <td class="right">{{ item.part_pymt_remaning_amt }}</td>
          </tr>
        </ng-container>

        <!-- Summary Row -->
        <tr>
          <td></td>
          <td colspan="4" class="boldText">
            Total No of Advt: <b>{{ inDetailsRegReportTotal.total_advt }}</b>
          </td>
          <td colspan="4"></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.advt_total }}</b></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.net_amt }}</b></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.gst }}</b></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.total_amt }}</b></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.rcvd_amt }}</b></td>
          <td></td>
          <td class="right"><b>{{ inDetailsRegReportTotal.pndg_amt }}</b></td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>

<!-- Very Brief Report Section -->
<div *ngIf="type === 'Represantative very Briefly'" id="print-section" style="margin-top: 50px; margin-left: 40px;">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th colspan="2" class="br-bottom br-right br-top">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
        <th colspan="2" class="br-bottom br-right br-top">अंकाचे नाव: {{ newissuedatepp }}</th>
        <th colspan="2" class="br-bottom br-right br-top">Representative Very Briefly</th>
        <th colspan="1" class="br-bottom br-right br-top">अंकाचे कॅटेगरी: {{ issue_cat }}</th>
        <th colspan="2" class="br-bottom br-right br-top">
          Date: From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}
        </th>
        <th colspan="1" class="br-bottom br-right br-top">दिनांक: {{ today1 }}</th>
        <th colspan="1" class="br-bottom br-top">पृष्ठ क्र: 1</th>
      </tr>
      <tr>
        <th class="br-bottom br-right">Sr</th>
        <th class="br-bottom br-right">Issue Seller Name</th>
        <th class="br-bottom br-right">Representative</th>
        <th class="br-bottom br-right">Issue Copies</th>
        <th class="br-bottom br-right" style="text-align: end;">Issue Seller Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">Net Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">Before GST Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">GST Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">Total Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">Receive Amt</th>
        <th class="br-bottom br-right" style="text-align: end;">Pending Amt</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let item1 of inDetailsRegReportrep; let repIndex = index">
        <tr class="group-header">
          <td colspan="3">Representative Name: {{ item1.rep_name }}</td>
          <td colspan="3">Mobile Number: {{ item1.rep_mob_no }}</td>
          <td colspan="6"></td>
        </tr>

        <ng-container *ngFor="let item of item1.issue_data; let i = index">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ item.issue_seller_name }}</td>
            <td>{{ item.rep_name }}</td>
            <td>{{ item.isuuecopies }}</td>
            <td class="text-end">{{ item.issue_amt }}</td>
            <td class="text-end">{{ item.amount }}</td>
            <td class="text-end">{{ item.beforegst_amt }}</td>
            <td class="text-end">{{ item.gst }}</td>
            <td class="text-end">{{ item.total_amount }}</td>
            <td class="text-end">{{ item.pymt_rcv_amt }}</td>
            <td class="text-end">{{ item.remaining_amt }}</td>
          </tr>
        </ng-container>

        <tr class="group-total">
          <td>{{ item1.issue_data.length }}</td>
          <td colspan="3" class="text-center fw-bold">एकूण</td>
          <td class="text-end fw-bold">{{ item1.total_advt_amount }}</td>
          <td class="text-end fw-bold">{{ item1.total_discounted_amt }}</td>
          <td class="text-end fw-bold">{{ item1.total_before_gst }}</td>
          <td class="text-end fw-bold">{{ item1.total_gst }}</td>
          <td class="text-end fw-bold">{{ item1.total_amt }}</td>
          <td class="text-end fw-bold">{{ item1.total_rcv }}</td>
          <td class="text-end fw-bold">{{ item1.total_pending }}</td>
        </tr>
      </ng-container>
    </tbody>

    <tfoot>
      <tr class="grand-total">
        <td colspan="3" class="text-center fw-bold">Final Total</td>
        <td class="text-end fw-bold">{{ copies }}</td>
        <td class="text-end fw-bold">{{ grand_total_advt | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_discounted | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_before_gst | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_gst | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_amt | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_rcv | number: '1.2-2' }}</td>
        <td class="text-end fw-bold">{{ grand_total_pending | number: '1.2-2' }}</td>
      </tr>
    </tfoot>

  </table>

</div>